import { Group, Modal, Stack, Text, Title } from "@mantine/core";
import { SessionActions } from "../Layout/SessionActions";
import { Plans } from "./Plans";
import classes from "./PricingModal.module.css";

export function PricingModal({
  opened,
  onClose,
}: {
  opened: boolean;
  onClose?: () => void;
}) {
  if (!opened) {
    return null;
  }

  return (
    <Modal
      onClose={onClose ?? (() => {})}
      opened={opened}
      size="auto"
      radius="lg"
      closeOnClickOutside={!!onClose}
      closeOnEscape={!!onClose}
      withCloseButton={!!onClose}
      overlayProps={{ backgroundOpacity: 0.45 }}
      styles={{ header: { justifyContent: "center" } }}
      title={
        <Group gap="xs" className={classes.modalTitle}>
          <Title order={2} fw="bold" ta="center">
            Pricing that scales with your business
          </Title>
        </Group>
      }
    >
      <Stack className={classes.modalContent}>
        <Text ta="center">
          Start as a solo founder. Scale into a team. Run an entire enterprise
          on the same fact layer.
        </Text>
        <Plans />
        {!onClose && (
          <Group justify="center">
            <SessionActions menuPosition="top" />
          </Group>
        )}
      </Stack>
    </Modal>
  );
}
